import imageIdeas from '@assets/img/svg/ideas.svg'
import MySquid from '@interfaces/my-squid.interface'
import onConfigChange from '@observables/config.obvervable'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Subscription } from 'rxjs'
import './banner-ideas.component.scoped.scss'

export default ({ className = '' }: React.HTMLAttributes<HTMLDivElement>) => {
  const [t] = useTranslation('bannerIdeas')
  const [configs, setConfig] = useState<MySquid>(null)
  const onConfigChangeSubscription = useRef<Subscription>(undefined)

  useEffect(() => {
    onConfigChangeSubscription.current = onConfigChange.subscribe((configChanged: MySquid) => {
      if (configChanged?._id) {
        setConfig(configChanged)
      }
    })
    return () => {
      onConfigChangeSubscription.current?.unsubscribe()
    }
  }, [onConfigChangeSubscription])

  if (configs?._id) {
    return null
  }

  return (
    <a className={`${className} banner-ideas`} target="_blank" href="https://squidinfluencers.typeform.com/to/URI2xmUd">
      <figure>
        <img src={imageIdeas} className="img-fluid" title="Banner Ideas" alt="Banner Ideas" />
      </figure>
      <article>
        <h2 dangerouslySetInnerHTML={{ __html: t('title') }} />
        <p dangerouslySetInnerHTML={{ __html: t('p1') }} />
        <footer>
          <p className="last">
            <small>{t('p2')}</small>
          </p>
          <span className="button button-pink button-sm rounded">{t('more')}</span>
        </footer>
      </article>
    </a>
  )
}
